import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private readonly _http = inject(HttpClient);

  addNote(data: any): Observable<any> {
    return this._http.post<any>(BASEURL + 'notes', data).pipe(catchError(this.handleError));
  }

  deleteNote(id: number): Observable<any> {
    return this._http.delete<any>(BASEURL + 'notes/' + id).pipe(catchError(this.handleError));
  }

  updateNote(id: number, data: any): Observable<any> {
    return this._http.put<any>(BASEURL + 'notes/' + id, data).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse) => {
    let errorMessage = 'Error en el servicio de Notas.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('NoteService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
